import { Flex, VStack, Button, Heading, Text, Divider, Icon, Link, Spacer, useColorModeValue as colorValue, useDisclosure, Drawer, DrawerOverlay, DrawerContent, Hide } from '@chakra-ui/react'
import Header, { Logo } from './Header'
import Footer from './Footer'
import AuthorizedContent from './AuthorizedContent'
import { BsDot, BsPerson } from 'react-icons/bs'
import { useUserContext } from '../../context/userContext'
import mainMenuData from '../../assets/data/mainMenuList'
import { Link as ReactLink, useRouteMatch as match } from 'react-router-dom'

const HeadMainMenu = () => {
    const { userData } = useUserContext()
    return (
        <Flex direction="column" p={6} align="center" mt={{base:"10px",md:"60px"}} >
            <Hide above="md"><Logo /></Hide>
            <Heading size="md" mt={4}>ยินดีต้อนรับ</Heading>
            <Flex align="center" mt={2}>
                <Icon as={BsPerson} mr={2} />
                <Text>{userData.full_name}</Text>
            </Flex>
            <Text fontSize="sm" color="blue.600">{userData.role_name}</Text>
        </Flex>
    )
}

const MenuDivider = ({ title }) => {
    return (
        title ?
            <Flex w="full" direction="column">
                <Flex w="full" align="center">
                    <Icon as={BsDot} />
                    <Text fontSize="xs" noOfLines={1}>{title}</Text>
                </Flex>
                <Divider />
            </Flex>
            : <Divider />
    )
}

const MainMenuItem = ({ data, onClose }) => {
    const { userData } = useUserContext()
    const isDisplay = !data.roles || (data.roles && data.roles.includes(userData.role_id))
    //
    const closeMenu = ()=>{
        if(onClose){
            onClose()
        }
    }
    return (
        isDisplay && (
            data.divider ? <MenuDivider title={data.title} /> :
                <Link as={ReactLink} to={data.path} w="full">
                    <Button leftIcon={<Icon as={data.icon} />}
                        w="full" variant="ghost"
                        justifyContent="start"
                        isActive={match(data.path)}
                        onClick={closeMenu}
                    >{data.name}</Button>
                </Link>
        )
    )
}

const ListMainMenu = ({onClose}) => {
    return (
        <VStack w="full" p={4}>
            {
                mainMenuData.map((item, i) => (<MainMenuItem key={i} data={item} onClose={onClose} />))
            }
        </VStack>
    )
}

const MainMenu = ({ onClose, ...rest }) => {
    return (
        <VStack w="270px" h="100%" position="fixed" top="0px" overflow="auto"
            backgroundImage={colorValue('menubg.jpg', '')}
            backgroundSize='cover'
            backgroundPosition='top'
            zIndex={1}
            css={{
                /* width */
                '&::-webkit-scrollbar': {
                    width: '4px'
                },

                /* Handle */
                '&::-webkit-scrollbar-thumb': {
                    background: colorValue('#CBD5E0', '#718096')
                },

                /* Handle on hover */
                '&::-webkit-scrollbar-thumb:hover': {
                    background: colorValue('#A0AEC0', '#4A5568')
                },
            }}
            {...rest}>
            <HeadMainMenu />
            <Divider />
            <ListMainMenu onClose={onClose}/>
        </VStack>
    )
}

const AuthorizedLayout = () => {
    const sidebar = useDisclosure();
    return (
        <Flex direction="column">
            <Header sidebarOpen={sidebar.onOpen} />
            <Flex>
                <MainMenu display={{ base: "none", md: "unset" }} />
                <Drawer
                    isOpen={sidebar.isOpen}
                    onClose={sidebar.onClose}
                    placement="left"
                >
                    <DrawerOverlay />
                    <DrawerContent>
                        <MainMenu w="full" borderRight="none" onClose={sidebar.onClose}/>
                    </DrawerContent>
                </Drawer>
                <Flex direction="column" ml={{ base: "", md: "280px" }} pt="60px" w="full" minH="100vh">
                    <AuthorizedContent />
                    <Spacer bgColor={colorValue("gray.100", "gray.600")} />
                    <Footer />
                </Flex>
            </Flex>
        </Flex>
    )
}

export default AuthorizedLayout
